"use client";

import React from "react";
import InvitationCardMobile from "../PartyInvitationCard/InvitationCardMobile";
import { MobileInvitationFrame } from "../PartyInvitationCard/MobileInvitationFrame";
import InvitationCard from "../PartyInvitationCard/InvitationCard";

/** Skeleton matching party invite card: avatar, title, members, CTA. */
export function PartyInvitePageSkeleton(): React.ReactElement {
  return (
    <>
      <div
        className="hidden lg:flex min-h-dvh items-center justify-center px-4 md:px-8 py-6"
        style={{
          background: "url(/static/bg-invitation-card.png)",
          backgroundSize: "cover",
          backgroundRepeat: "repeat",
        }}
      >
        <div className="w-full max-w-5xl flex flex-col items-center justify-center border border-orange-2 rounded-3xl bg-background-light p-6 md:p-10">
          <InvitationCard qrCodeURL="" loadingQr />
        </div>
      </div>
      <MobileInvitationFrame>
        <InvitationCardMobile qrCodeURL="" loadingQr />
      </MobileInvitationFrame>
    </>
  );
}
